import Snap from 'snapsvg'

//グローバルMAP
export function mapSvgFunc() {
	
	// 共通関数
	const commonFunc = {
		svgLoaded: function(fileName) {
			return new Promise((resolve, reject) => {
				const paper = Snap().remove();
				Snap.load(fileName, function(svg) {
					paper.attr('viewBox', svg.node.viewBox.baseVal.x + " " + svg.node.viewBox.baseVal.y + " " + svg.node.viewBox.baseVal.width + " " + svg.node.viewBox.baseVal.height);
					paper.attr('xmlns', 'http://www.w3.org/2000/svg');
					paper.append(svg.selectAll('svg>*'));
					resolve(paper);
				});
			});
		}
	}

	// インライン化するオブジェクトのセレクタ
	let objList = ['img.svgImgPc','img.svgImgSp'];
	objList = objList.map(selector => document.querySelector(selector));

	Promise.all(objList.map(elm => {
		return new Promise((resolve, reject) => {
			let path = elm.getAttribute('src');
			Promise.resolve()
				.then(function() {
					return commonFunc.svgLoaded(path);
				})
				.then(targetSvg => {
					let parentDom = elm.parentNode;
					parentDom.replaceChild(targetSvg.node, elm);
					resolve(targetSvg);
				})
		 })
	}))
	.then(svgObj => {

		/*****************************************
			/ここからjs処理を書きます
			*****************************************/			
			let letThisMap,letContinent,letCountryArea,letChangeJs,letAreaList,letCurrentList,letMapName,letResponsibleCheck,letSelectBtn;
		
			letThisMap = $('#globalMap').find('g.global_map').find('g');
			letCountryArea = $('section.countryList');
			letChangeJs = $('#changeJs li');
		
			letThisMap.hover(
				function () {
					//マウスカーソルが重なった時の処理
					letContinent = $(this).attr('id');
					//色付け
					$(this).find('path').addClass('cls-3');
					//文字色替え
					$(this).find('text').addClass('cls-4');
				},
				function () {
					//マウスカーソルが離れた時の処理
					//色付け
					$(this).find('path').removeClass('cls-3');
					//文字色替え
					$(this).find('text').removeClass('cls-4');
				}
			);

			letThisMap.on('click',function(){
				// 表示するリスト
				letAreaList = $('section.'+letContinent);
				// 選択したマップと同じサブナビ
				letCurrentList = $('#changeJs li.'+letContinent);

				if ($(letAreaList).css('display') == 'none') {
					//取得したクラスのリストのみ表示
					letCountryArea.not(letAreaList).css('display','none');
					letAreaList.css('display','block');
				}

				//マップのカレント
				letThisMap.removeClass('current');
				$(this).addClass('current');

				//サブナビのカレント
				letChangeJs.removeClass('current');
				letCurrentList.addClass('current');

				// タップしたマップの名前取得
				letMapName = $(this).find('text').attr('id');
				//セレクトボタンに代入
				$('.currentItem').html(letMapName);
				
				// SP時、マップ選択時サブナビ閉じる
				letResponsibleCheck = $('#responsibleCheck').width();
				letSelectBtn = $('.selectBtn');
				
				if(letResponsibleCheck == '2') {
					$('#changeJs').slideUp(500);
					letSelectBtn.removeClass('open');
				}

			});
			/*****************************************
			/ここまで
			*****************************************/
	});
	
}


